class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // Listen for Swym add to cart event and update drawer contents dynamically
    document.addEventListener('swym:addedtocart', () => {
      this.updateDrawerContents();
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (window.Sentry) {
      window.Sentry.addBreadcrumb({ category: "cart", message: "Cart drawer opened", level: "info" });
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    const offerDrawerWrapper = document.querySelector('#cart-drawer-offer-drawer-wrapper');
    const cartDrawerPincodeWrapper = document.querySelector('.cart__drawer-pincode-input-wrapper .cart-drawer--inner-input');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if (offerDrawerWrapper) {
      offerDrawerWrapper.classList.remove('open');
    }
    if (cartDrawerPincodeWrapper) {
      cartDrawerPincodeWrapper.classList.remove('open');
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      const sectionHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (sectionHTML === null) return;

      sectionElement.innerHTML = sectionHTML;
    });

    // Re-bind overlay click to close after updating content.
    // #CartDrawer-Overlay is recreated by the innerHTML replacement above, so this
    // must re-query rather than reuse the reference captured in the constructor.
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  updateDrawerContents() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Assuming you have a <script id="CartDrawer-Json"> in your liquid
        const cartJsonScript = doc.querySelector('#CartDrawer-Json');
        if (!cartJsonScript) {
          console.error('CartDrawer JSON script tag not found');
          if (window.ZiglyCapture) {
            window.ZiglyCapture(new Error('CartDrawer JSON script tag not found'), { feature: 'cart_drawer' });
          }
          return;
        }
        const parsedState = JSON.parse(cartJsonScript.textContent);
        this.renderContents(parsedState);
      })
      .catch((error) => {
        console.error('Error updating cart drawer:', error);
        if (window.ZiglyCapture) window.ZiglyCapture(error, { feature: 'cart_drawer' });
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const sectionNode = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!sectionNode) {
      console.error(`[cart-drawer] Expected node missing in fetched section HTML: selector="${selector}"`);
      return null;
    }
    return sectionNode.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// workign cart-drawer js code